import React from 'react';

import { Badge, BadgeProps } from '../';
import { StyledBadgeWrapper } from './styled';

type Props = {
  badges: BadgeProps[];
};

const BadgeList = ({ badges }: Props): JSX.Element => (
  <StyledBadgeWrapper data-testid="badgeListWrapper">
    {badges.map((badge, number) => (
      <Badge key={`badge${number}`} dataTestId={`badge${number}`} {...badge} />
    ))}
  </StyledBadgeWrapper>
);

export default BadgeList;
